// useQueryParams.ts
import { useLocation } from 'react-router-dom';

type QueryParams = Record<string, string>;

const useQueryParams = () => {
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);

    const getParam = (key: string): string | null => queryParams.get(key);

    const getAll = (): QueryParams => {
        const entries: QueryParams = {};

        queryParams.forEach((value, key) => {
            entries[key] = value;
        });

        return entries;
    };

    return { getParam, getAll };
};

export default useQueryParams;
